import Link from '../../views/TransApproveMsg';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions } from '../../../state/assessment';
import { actions as assessmentactions } from '../../../state/assessment';
const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  project: state.shift.project[ownProps.match.params.projectId],
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  reponame: state.shift.assessment.reponame,
  reference_id: state.shift.assessment.reference_id,
  quotation_id: state.shift.assessment.quotation_id,
  financialforce_Id: state.shift.assessment.financialforce_Id,
  po_num: state.shift.assessment.po_num,
  translationRate: state.shift.assessment.translationRate,
  username:state.shift.auth.username
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickOKHandler: value => {
      dispatch(push(`/${locale}/shift`));
      dispatch(assessmentactions.resetAssessmentStore());
    },


    approvetranslation: (reponame,reference_id, opportunity_num,translationRate,username) => {


      //alert(JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['quotation_id']),
      dispatch(actions.approvetranslation(
      JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['reponame'],
      JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['reference_id'],
      JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['financialforce_Id'],
      JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['translationRate'],
      JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['auth'])['username'])
      // JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['auth']['username'])
       );
    }
  };
};

const TransApproveMsg = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default TransApproveMsg;



// WEBPACK FOOTER //
// ./src/components/container/TransApproveMsg/index.js